import JoinContainer from "components/Join/Join.container";

const JoinPage = () => {
  return <JoinContainer />;
};

export default JoinPage;
